/*
 * PRC custom scripts — rewritten vanilla JS for the Impulse 9.1.0 upgrade
 * (previously jQuery-based). Loaded via snippets/prc-header-assets.liquid.
 */

// Initialize tippy tooltips on any [data-tippy-content] elements (header icons, etc.)
document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.tippy === 'function') {
    window.tippy('[data-tippy-content]');
  }
});

// Expandable "hidden block" text: clicking .hidden-block-show toggles the
// adjacent .hidden-block-text element (replaces jQuery .next().slideToggle()).
document.addEventListener('click', function (e) {
  var trigger = e.target.closest('.hidden-block-show');
  if (!trigger) return;
  e.preventDefault();
  var target = trigger.nextElementSibling;
  if (target && target.classList.contains('hidden-block-text')) {
    target.style.display = (target.style.display === 'block') ? 'none' : 'block';
  }
});

// "Read More" for team bios (About page). Bios are text-columns blocks whose <h3> title uses a
// "Name | Role" format. Keep the FIRST paragraph visible and tuck the remaining paragraphs into
// a wrapper that expands inline (page reflows down) with a smooth max-height transition — so the
// split lands at a clean paragraph boundary, never mid-sentence.
document.addEventListener('DOMContentLoaded', function () {
  var blocks = document.querySelectorAll('.text-column__grid > div');
  Array.prototype.forEach.call(blocks, function (block) {
    var h3 = block.querySelector('h3');
    var rte = block.querySelector('.rte-setting');
    if (!h3 || !rte) return;
    if (h3.textContent.indexOf('|') === -1) return; // bios only ("Name | Role")

    var paras = rte.querySelectorAll(':scope > p');
    if (paras.length < 2) return; // single paragraph -> nothing to collapse

    // Move paragraphs after the first into a collapsible wrapper.
    var wrap = document.createElement('div');
    wrap.className = 'prc-bio-more';
    rte.insertBefore(wrap, paras[1]);
    for (var i = 1; i < paras.length; i++) wrap.appendChild(paras[i]);

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'prc-bio-toggle';
    btn.textContent = 'Read More';
    btn.setAttribute('aria-expanded', 'false');

    // After opening, drop the fixed height so the content can reflow freely (e.g. on resize).
    wrap.addEventListener('transitionend', function () {
      if (btn.getAttribute('aria-expanded') === 'true') wrap.style.maxHeight = 'none';
    });

    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-expanded') === 'true') {
        wrap.style.maxHeight = wrap.scrollHeight + 'px'; // from 'none' -> fixed, then animate to 0
        void wrap.offsetHeight;
        wrap.style.maxHeight = '0';
        btn.textContent = 'Read More';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        wrap.style.maxHeight = wrap.scrollHeight + 'px';
        btn.textContent = 'Read Less';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    rte.parentNode.insertBefore(btn, rte.nextSibling);
  });
});

/* ---------------------------------------------------------------------------
   PRC: managed filter lists (collection sidebar)

   Shopify displays at most 100 values per filter, and never reports a value
   outside that 100 as active — so for values rendered by
   prc-collection-filter-list.liquid, Liquid cannot know they are applied.
   The filtering itself is uncapped; only the value list is capped.

   This restores, from the URL, what Shopify won't tell the theme:
     - the checked state of managed inputs
     - a removable chip, so a customer can clear a filter they can see

   Re-runs after the collection AJAX swaps #CollectionAjaxContent, which
   re-renders the lists server-side (and therefore unchecked).
--------------------------------------------------------------------------- */
(function () {
  // Build marker: readable at window.PRC_FILTER_BUILD and as a string literal in
  // the served asset. Shopify strips comments from theme JS, so a comment cannot
  // confirm which version is deployed — this can. Bump on each change.
  window.PRC_FILTER_BUILD = 'prc-filters-build-9-checkbox-style-tag-links';

  var CHIP_ATTR = 'data-prc-chip';
  var observer = null;

  function params() {
    return new URLSearchParams(window.location.search);
  }

  // Current URL minus this one param=value pair, preserving all others.
  function removeUrlFor(param, value) {
    var p = params();
    var kept = p.getAll(param).filter(function (v) { return v !== value; });
    p.delete(param);
    kept.forEach(function (v) { p.append(param, v); });
    var qs = p.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function renderChips(active) {
    document.querySelectorAll('.tag-list--active-tags').forEach(function (ul) {
      ul.querySelectorAll('[' + CHIP_ATTR + ']').forEach(function (el) { el.remove(); });

      active.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'tag tag--remove';
        li.setAttribute(CHIP_ATTR, '');

        var a = document.createElement('a');
        a.className = 'btn btn--small';
        a.href = removeUrlFor(item.param, item.value);
        a.textContent = item.value; // textContent: value comes from the URL
        li.appendChild(a);

        li.insertAdjacentHTML('beforeend',
          '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64">' +
          '<path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"/></svg>');

        ul.appendChild(li);
      });
    });
  }

  function apply() {
    var p = params();
    var active = [];
    // The filter form renders once per location (sidebar + drawer), so each
    // param owns two lists. Chips are per param+value, not per list, or each
    // value would be chipped once per copy.
    var seen = {};

    // Tag-path links lose the query string: link_to_add_tag emits a bare path, so
    // adding a grape would silently drop an active Country/Type/Vintage filter.
    // Re-attach the current metafield params to every tag link.
    document.querySelectorAll('.prc-filter-list[data-prc-filter-mode="tag"] a').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.indexOf('?') !== -1) return;
      var keep = new URLSearchParams();
      params().forEach(function (v, k) {
        if (k.indexOf('filter.') === 0) keep.append(k, v);
      });
      var qs = keep.toString();
      if (qs) a.setAttribute('href', href + '?' + qs);
    });

    document.querySelectorAll('.prc-filter-list').forEach(function (list) {
      var param = list.getAttribute('data-prc-filter-param');
      // Tag mode: current_tags is server-side, so Liquid already rendered the
      // active state and the chips. Nothing for us to restore.
      if (list.getAttribute('data-prc-filter-mode') === 'tag') return;
      if (!param) return;

      var applied = p.getAll(param);

      list.querySelectorAll('input.tag__input').forEach(function (input) {
        var on = applied.indexOf(input.value) !== -1;
        input.checked = on;
        var li = input.closest('li');
        if (li) li.classList.toggle('tag--active', on);
      });

      // Chip every applied value, including ones this list no longer offers.
      // A value can be applied and yet pruned from the list (e.g. it sold out
      // while the customer was browsing); the chip is then the only way to
      // clear it, so an unchippable filter would trap them on empty results.
      applied.forEach(function (value) {
        var key = param + ' ' + value;
        if (seen[key]) return;
        seen[key] = true;

        // Shopify already chipped this one (it is inside its 100) and its
        // url_to_remove is authoritative -- leave it be. Matched on param+value
        // rather than label: values collide across filters (Romania is both a
        // Country and a Region).
        if (hasNativeChip(param, value)) return;

        active.push({ param: param, value: value });
      });
    });

    renderChips(active);
  }

  // Did Shopify render its own chip for this param+value?
  function hasNativeChip(param, value) {
    var chips = document.querySelectorAll('li[data-prc-native-chip]');
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('data-prc-param') === param &&
          chips[i].getAttribute('data-prc-value') === value) {
        return true;
      }
    }
    return false;
  }

  // Disconnect while we mutate, or our own chip writes retrigger the observer.
  function safeApply() {
    if (observer) observer.disconnect();
    apply();
    if (observer) observe();
  }

  function observe() {
    var target = document.getElementById('CollectionAjaxContent');
    if (target && observer) {
      observer.observe(target, { childList: true, subtree: true });
    }
  }

  function init() {
    if (!document.querySelector('.prc-filter-list')) return;

    // Trailing-edge debounce, deliberately NOT an immediate apply. The AJAX
    // renderer swaps the DOM and updates history at around the same moment, so
    // applying immediately can read a stale URL and chip the previous value
    // next to the server's new native chip -- a visible double-chip flash until
    // a follow-up corrects it. Waiting for the URL to settle renders once.
    var pending = null;
    observer = new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(safeApply, 120);
    });

    safeApply();
    observe();

    window.addEventListener('popstate', safeApply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
